import createSvgIcon from './svg-icon';

export const XIcon = createSvgIcon(
    <path d="M 13.894531 10.480469 L 21.296875 2.0625 L 19.542969 2.0625 L 13.113281 9.367188 L 7.980469 2.0625 L 2.0625 2.0625 L 9.824219 13.113281 L 2.0625 21.9375 L 3.816406 21.9375 L 10.601562 14.21875 L 16.019531 21.9375 L 21.941406 21.9375 Z M 4.449219 3.355469 L 7.140625 3.355469 L 19.542969 20.707031 L 16.847656 20.707031 Z M 4.449219 3.355469 "/>,
    'X'
);
